import { render, staticRenderFns } from "./language_evidence.vue?vue&type=template&id=794c67fb&"
import script from "./language_evidence.vue?vue&type=script&lang=js&"
export * from "./language_evidence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports